import React from "react"

const FieldLabel = ({ forId, children, ...style }) => 
    <label htmlFor={forId} style={{ marginTop: 3, display: "inline-block", ...style }}>
        {children}
    </label>

const Field = props => {
    const { isBox, label, name, value, id, style, sub } = props;

    const baseStyle = { fontSize: '14px', width: '100%', padding: 5 };
    const inputStyle = isBox ? { ...baseStyle, border: "1px solid black" } 
        : { ...baseStyle, borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid black" }

    return <div style={{ flex: 1, ...style }}>
        <input readOnly defaultValue={value} id={id} name={name} style={inputStyle} />
        <div>
            <FieldLabel forId={id}>{label}</FieldLabel>
            {sub && <span style={{ marginLeft: 60, fontSize: 10 }}>{sub}</span>}
        </div>
    </div>
}


export default Field;
